import { render, staticRenderFns } from "./LCfile.vue?vue&type=template&id=a24cecce"
import script from "./LCfile.vue?vue&type=script&lang=js"
export * from "./LCfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports